export default "__VITE_ASSET__CKgj_PoP__"